/* eslint no-unused-vars: 0 */
import React, { useState } from 'react';
import { Form, Input, Button, message, Row, Col } from 'antd';
import ResultPage from './ResultPage.js';
import Features from './Features';
import axios from 'axios';
import qs from 'qs';
import PhoneInput2 from 'react-phone-input-2';
import ru from 'react-phone-input-2/lang/ru.json';
import logo from '../assets/images/lb-logo.png';

const TrialForm = () => {
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [duplicateId, setDuplicateId] = useState(null);

  const onFinish = (values) => {
    setLoading(true);
    axios({
      method: 'post',
      url: '/cgi-bin/',
      data: qs.stringify(values),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' }
    })
      .then(function (response) {
        setStatus('SUCCESS');
      })
      .catch(function (error) {
        console.log('response', error.response.data);
        console.log('status:', error.response.status);
        // if (error.response.status === 409) {
        //   setDuplicateId(parseInt(error.response.data.results, 10));
        //   setStatus('FAIL');
        // } else {
        message.error(error.response.data.error || 'Неизвестная ошибка', 3);
        // }
      })
      .then(function () {
        setLoading(false);
      });
  };
  if (status) {
    return <ResultPage status={status} duplicateId={duplicateId} />;
  }
  return (
    <div className="signup">
      <Row align="middle" className="main-row">
        <Col xs={24} lg={12}>
          <Form form={form} layout="vertical" onFinish={onFinish} className="signup__form">
            <div className="logo">
              <img src={logo} alt="LANbilling" className="image" />
              <h1>LANBilling</h1>
            </div>
            <Form.Item
              label="Компания"
              name="companyname"
              rules={[{ required: true, message: 'Введите название компании' }]}>
              <Input />
            </Form.Item>
            <Form.Item
              label="Имя"
              name="firstname"
              rules={[{ required: true, message: 'Введите имя' }]}>
              <Input />
            </Form.Item>

            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, type: 'email', message: 'Введите email' }]}>
              <Input />
            </Form.Item>
            <Form.Item
              name="phone"
              label="Телефон"
              rules={[
                {
                  required: true,
                  message: 'Введите телефон'
                }
              ]}>
              <PhoneInput2
                country={'ru'}
                countryCodeEditable={false}
                inputStyle={{ width: '100%' }}
                inputClass="phone-input"
                preferredCountries={['kz', 'ru']}
                localization={ru}
              />
            </Form.Item>
            <Form.Item label="Факс" name="fax" hidden>
              <Input />
            </Form.Item>
            <Form.Item label="Город" name="city" hidden>
              <Input />
            </Form.Item>
            <Form.Item label="Комментарий" name="comment">
              <TextArea />
            </Form.Item>
            <Button
              type="primary"
              className="signup__button"
              htmlType="submit"
              size="large"
              loading={loading}>
              Зарегистрироваться
            </Button>
          </Form>
        </Col>
        <Col md={24} lg={12}>
          <Features />
        </Col>
      </Row>
    </div>
  );
};

export default TrialForm;
